import React, { lazy } from 'react';
import { Check } from 'lucide-react';
export function SolutionSection() {
  const tomos = [{
    name: 'The Offensive Masterclass',
    desc: 'Master attacking transitions and fast-paced ball distribution.'
  }, {
    name: 'The Defensive Wall',
    desc: 'Serving, serve-receive, and back-row defensive organization techniques.'
  }, {
    name: 'Scouting & Tactics Pro',
    desc: 'Real game-read strategies, precise positioning, and adaptable systems.'
  }, {
    name: 'Skill-Specific Drills',
    desc: 'Setting, Hitting, Blocking, and Digging — mastered through repetition.'
  }, {
    name: 'Volleyball-Specific S&C',
    desc: 'Cardio, agility, and strength training without the need for heavy gym equipment.'
  }, {
    name: 'Gameday & Leadership',
    desc: 'Pre-game speeches, timeout management, and team psychology.'
  }];
  return <section className="bg-pilates-cream py-20 px-4 sm:px-6 lg:px-8 border-t border-pilates-slate/10" data-id="element-219">
      <div className="max-w-5xl mx-auto" data-id="element-220">
        <div className="text-center mb-12" data-id="element-221">
          <div className="bg-pilates-blue-dark border border-pilates-lavender text-white font-semibold text-xs px-4 py-1.5 mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-222">
            THE SOLUTION YOU'VE BEEN WAITING FOR — A 6-IN-1 SYSTEM
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-pilates-blue-dark leading-tight mb-4 tracking-tight" data-id="element-223">
            6 Books in 1, specifically designed for{' '}
            <span className="italic text-pilates-rose" data-id="element-224">
              "In-The-Trenches" coaches
            </span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-10 items-center" data-id="element-225">
          <div data-id="element-226">
            <img src="https://cdn.magicpatterns.com/uploads/3BeFdoayiknhsrXtc74pGh/image_(3).webp" alt="VolleyReady 6-in-1 Bundle" className="w-full rounded-2xl shadow-xl" loading="lazy" decoding="async" width="800" height="800" data-id="element-227" />
          </div>

          <div data-id="element-228">
            <div className="border-l-4 border-pilates-lavender pl-4 mb-8" data-id="element-229">
              <p className="text-pilates-slate text-base leading-relaxed" data-id="element-230">
                <span className="font-bold text-pilates-blue-dark" data-id="element-231">
                  VOLLEYREADY
                </span>{' '}
                is much more than a simple book of drills. It's a complete
                operational system that delivers pedagogically structured
                sessions to guarantee intensity and confidence on the court.
              </p>
            </div>

            <ul className="space-y-5" data-id="element-232">
              {tomos.map((tomo, idx) => {
              const roman = ['I', 'II', 'III', 'IV', 'V', 'VI'][idx];
              return <li key={idx} className="flex items-start gap-4" data-id="element-233">
                    <div className="mt-0.5 bg-pilates-blue-dark text-pilates-lavender w-8 h-8 rounded-sm flex items-center justify-center flex-shrink-0 font-display font-bold text-sm shadow-sm" data-id="element-234">
                      {roman}
                    </div>
                    <div data-id="element-235">
                      <span className="font-bold text-pilates-blue-dark block mb-0.5" data-id="element-236">
                        {tomo.name}
                      </span>
                      <span className="text-pilates-slate text-sm" data-id="element-237">
                        {tomo.desc}
                      </span>
                    </div>
                  </li>;
            })}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}